export const SUPPORTS_ARRAY_PROTOTYPE_EVERY = "every" in Array.prototype;
